import { PageHeader } from '../components/PageHeader';
import { DocumentIcon } from '@heroicons/react/24/outline';
import { entityViewTitle } from '../components/ID';
import { useDocumentTitle } from '../hooks/useDocumentTitle';
import { useQuery } from '@tanstack/react-query';
import backend from '../services/backend';
import { useParams } from 'react-router-dom';
import { UploadDetailsSection } from './uploadView/UploadDetailsSection';
import { InputDetailsSection } from './uploadView/InputDetailsSection';
import { DocumentsDetailsSection } from './uploadView/DocumentsDetailsSection';

export default function UploadView() {
  const { id } = useParams<{ id: string }>();
  useDocumentTitle(entityViewTitle(id, 'Upload View'));

  const uploadQuery = useQuery({
    queryKey: ['upload', id],
    queryFn: () => backend.getUpload(id!).then((res) => res.data),
    enabled: !!id,
  });

  return (
    <div>
      <PageHeader
        title={entityViewTitle(id, 'Upload View')}
        description="View your upload"
        icon={<DocumentIcon className="size-6" />}
        showBackButton={true}
      >
        <div className="flex items-center gap-4">
          <p className="text-sm text-gray-500 dark:text-zinc-400" />
        </div>
      </PageHeader>

      <div className="grid grid-cols-1 sm:grid-cols-1 gap-4">
        <UploadDetailsSection uploadQuery={uploadQuery} />
        <InputDetailsSection uploadQuery={uploadQuery} />
        <DocumentsDetailsSection uploadQuery={uploadQuery} />
      </div>
    </div>
  );
}
